import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../../../Atoms';
import { WeekDays } from '../../index.constants';
import { DateRangeContext } from '../../index.context';
import { StyledDays, StyledDay, StyledWeekDays } from './index.styles';
import { MAX_DAYS_IN_CALENDAR } from './index.constants';

const weekDaysSubstr = WeekDays.map(weekDay => weekDay.substring(0, 3));

export const Days = ({ onSelect, date }) => {
    const { dispatch, state } = useContext(DateRangeContext);

    const stateYear = state[date].getFullYear();
    const stateMonth = state[date].getMonth();

    const firstWeekDayOfMonth = new Date(stateYear, stateMonth, 1).getDay();
    const nextMonth = new Date(stateYear, stateMonth + 1, 1);
    const lastMonth = new Date(stateYear, stateMonth, 0);
    const lastDayOfLastMonth = lastMonth.getDate();

    const [days, setDays] = useState([]);

    const generateDays = () => {
        const calendarDays = Array.from({
            length: new Date(stateYear, stateMonth + 1, 0).getDate(),
        }).map((value, index) => ({
            day: index + 1,
            month: stateMonth,
            year: stateYear,
        }));
        Array.from(Array(firstWeekDayOfMonth)).forEach((_, index) => {
            calendarDays.unshift({
                day: lastDayOfLastMonth - index,
                month: lastMonth.getMonth(),
                year: lastMonth.getFullYear(),
            });
        });
        Array.from(Array(MAX_DAYS_IN_CALENDAR - calendarDays.length)).forEach((_, index) => {
            calendarDays.push({
                day: index + 1,
                month: nextMonth.getMonth(),
                year: nextMonth.getFullYear(),
            });
        });
        return calendarDays;
    };

    const isDaySelected = (day, month, year) => {
        const d = new Date(year, month, day);
        return (
            (state.selectedInitialDate &&
                state.selectedInitialDate.toLocaleDateString() === d.toLocaleDateString()) ||
            (state.selectedFinalDate &&
                state.selectedFinalDate.toLocaleDateString() === d.toLocaleDateString())
        );
    };

    const isDayInRange = (day, month, year) => {
        const d = new Date(year, month, day);
        return (
            state.selectedInitialDate &&
            state.selectedFinalDate &&
            d > state.selectedInitialDate &&
            d < state.selectedFinalDate
        );
    };

    const selectDay = (day, month, year) => {
        dispatch({ type: onSelect, year, month, day });
    };

    useEffect(() => {
        setDays(generateDays());
    }, [state]);

    return (
        <StyledDays>
            <StyledWeekDays>
                {weekDaysSubstr.map(weekDay => (
                    <Text key={weekDay}>{weekDay}</Text>
                ))}
            </StyledWeekDays>
            {days.map(({ day, month, year }) => (
                <StyledDay
                    key={`${year}/${month}/${day}`}
                    selected={isDaySelected(day, month, year)}
                    isInRange={isDayInRange(day, month, year)}
                    isOtherMonth={month !== stateMonth}
                    onClick={() => selectDay(day, month, year)}
                >
                    <Text>{day}</Text>
                </StyledDay>
            ))}
        </StyledDays>
    );
};

Days.propTypes = {
    onSelect: PropTypes.string,
    date: PropTypes.string,
};

/* istanbul ignore next */
Days.defaultProps = {
    onSelect: '',
    date: '',
};
